<template>
<div id="app">
  <header class="container-fluid" id="header">
    <div class="container">
      <b-media>
        <template #aside>
          <a href="http://www.ia2.inaf.it/" class="pull-left">
            <img alt="IA2 logo" src="./assets/ia2-logo-90x90.png">
          </a>
        </template>
        <p class="title">IA2 &ndash; Italian Center for Astronomical Archives</p>
        <p class="subtitle">User Account Management</p>
      </b-media>
    </div>
  </header>
  <div class="container">
    <router-view></router-view>
  </div>
  <div id="footer-fix"></div>
  <footer class="text-center" id="site-footer">
      Powered by <img alt="IA2 logo" src="./assets/ia2-logo-footer.png">
      <strong class="text-primary"><a href="http://www.ia2.inaf.it/" target="_blank">IA2</a></strong>
  </footer>
  <div id="loading" v-if="loading">
    <div class="spinner-wrapper">
      <b-spinner variant="primary" style="width: 3rem; height: 3rem;" label="Loading"></b-spinner>
    </div>
  </div>
</div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'App',
  computed: mapState({
    loading: state => state.loading
  }),
  mounted: function() {
    var self = this;
    document.addEventListener('apiError', function(event) {
      self.$bvToast.toast(event.message.body, {
        title: event.message.title,
        variant: 'danger',
        solid: true
      });
    });
    document.addEventListener('loading', function(event) {
      self.$store.commit('setLoading', event.value);
    });
  }
}
</script>

<style>
#header {
  margin-bottom: 20px;
  background-color: #8dd9ff;
  padding-top: 20px;
  padding-bottom: 20px;
  box-shadow: #777 0 0 10px;
}

#header .title {
  font-weight: bold;
  font-size: 190%;
  margin-bottom: 10px;
}

#header .subtitle {
  font-size: 150%;
  margin-bottom: 0;
}

#footer-fix {
    display: block;
    width: 100%;
    height: 100px;
}

#site-footer {
    color: #666;
    border-top: 1px #e7e7e7 solid;
    background-color: #f8f8f8;
    padding: 5px 0;
    position: fixed;
    bottom: 0;
    right: 0;
    left: 0;
}

#loading {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: rgba(255, 255, 255, 0.7);
  z-index: 1000;
}

.spinner-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
}
</style>
